import { useEffect, useState } from "react";
import PlanLimitModal from "@/components/PlanLimitModal";

const ITEM_LABELS_ES = {
  vault: "items en el cofre",
  messages: "mensajes",
  heirs: "herederos",
  contacts: "contactos de confianza",
  capsule: "cápsulas",
  stories: "historias",
  assets: "activos digitales",
};

/**
 * Listens to the global "ks:plan-limit" CustomEvent dispatched by axios
 * interceptor in /lib/api.js. Mounts the upgrade modal whenever a free
 * user hits a plan cap on any screen.
 */
export default function PlanLimitProvider() {
  const [state, setState] = useState({ open: false, limit: 0, item: "" });

  useEffect(() => {
    const handler = (e) => {
      const d = e?.detail || {};
      const item = ITEM_LABELS_ES[d.resource] || d.resource || "items";
      setState({ open: true, limit: d.limit ?? "?", item });
    };
    window.addEventListener("ks:plan-limit", handler);
    return () => window.removeEventListener("ks:plan-limit", handler);
  }, []);

  return (
    <PlanLimitModal
      open={state.open}
      onClose={() => setState((s) => ({ ...s, open: false }))}
      limit={state.limit}
      item={state.item}
    />
  );
}
